<app-spinner></app-spinner>
<div class="bg">
  <div class="loginbox">
    <img
      *ngIf="islight"
      class="logoimg"
      src="assets/img/logo@2xlight.png"
      alt="Ocular"
    />
    <!-- src="assets/img/logo@2x.png" -->
    <img
      *ngIf="!islight"
      class="logoimg"
      src="assets/img/ocular.png"
      alt="Ocular"
    />

    <p class="welcometext">Welcome to Synctag</p>
    <div *ngIf="ShowMobileScreen">
      <!-- <form [formGroup]="loginForm" (ngSubmit)="funcOnMobileNumberSubmit()"> -->

      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <mat-form-field class="example-full-width w80">
          <mat-label>Country</mat-label>
          <mat-select formControlName="countrycode" required>
            <mat-option
              *ngFor="let country of countrycodes"
              [value]="country.code"
            >
              <img class="flagimg" src="{{ country.img }}" /> &nbsp;&nbsp;
              {{ country.code }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="loginForm.controls['countrycode'].errors?.required"
            >Please choose a country</mat-error
          >
          <mat-hint></mat-hint>
        </mat-form-field>
        <mat-form-field class="example-full-width w100">
          <mat-label>Phone Number</mat-label>
          <input
            type="tel"
            matInput
            placeholder="Phone Number"
            formControlName="mobile"
            appAllowOnlyNumbers
          />
          <mat-error *ngIf="loginForm.controls['mobile'].errors?.required"
            >Please enter a valid mobile number</mat-error
          >
          <mat-error *ngIf="loginForm.controls['mobile'].errors?.minlength"
            >Mobile number should be 10 digit</mat-error
          >
          <mat-error *ngIf="loginForm.controls['mobile'].errors?.maxlength"
            >Mobile number should be 10 digit</mat-error
          >
          <mat-error *ngIf="loginForm.controls['mobile'].errors?.pattern"
            >Mobile number should be numbers</mat-error
          >
          <mat-hint></mat-hint>
        </mat-form-field>

        <div class="hint-txt">
          Tap next to verify your account with your phone number
        </div>
        <!-- <button
          mat-raised-button
          class="next-btn"
          color="warn"
          (click)="funcShowOtpScreen()"
        >
          Next
          <img class="float-right" src="assets/img/icons/right-arrow.svg" />
        </button> -->

        <input
          type="submit"
          value="Next"
          mat-raised-button
          class="next-btn"
          color="warn"
        />
      </form>
    </div>
    <div [ngClass]="{ 'display-none': ShowOtpScreen == false }">
      <!-- <div> -->
      <div class="otp_sec">
        <p>
          <span>Please enter the OTP sent to </span> <br />
          <b style="color: var(--textcolor4)">{{ phonenumber }}</b>
        </p>
        <div class="opt_txt">
          <ng-otp-input
            #ngOtpInputs
            (keydown)="keyDownFunctionOnVerifyOtp($event)"
            (onInputChange)="onOtpChange($event)"
            [config]="otpconfig"
          ></ng-otp-input>
          <mat-error *ngIf="!otpflag"> {{ otperrormsg }} </mat-error>
          <!-- <mat-error *ngIf="otpExpired"> -->
          <mat-error *ngIf="otpExpired">
            Otp is Expired{{ otperrormsg }}
          </mat-error>
        </div>
        <button
          mat-raised-button
          class="next-btn back-btn"
          color="warn"
          (click)="funcShowMobileScreen()"
        >
          <!-- <button mat-raised-button class="next-btn back-btn" color="warn"> -->
          <img class="float-left" src="assets/img/icons/left-arrow.png" /> Back
        </button>
        <div *ngIf="!timer" class="resendotp" (click)="ResendOtp()">
          RESEND OTP
        </div>
        <div *ngIf="timer" class="resendotp">
          Time Remaining : {{ timeLeft }}
        </div>
        <!-- <div class="resendotp">RESEND OTP</div> -->
        <div></div>

        <button
          mat-raised-button
          class="next-btn"
          [ngClass]="!otpflag ? 'disabled-btn' : ''"
          color="warn"
          (click)="funcVerifyOtp()"
          [disabled]="!otpflag"
        >
          Next
        </button>
        <!-- <button
          mat-raised-button
          class="next-btn"
          [ngClass]="!otpflag ? 'disabled-btn' : ''"
          color="warn"
          [disabled]="!otpflag"
        >
          Next
          <img class="float-right" src="assets/img/icons/right-arrow.svg" />
        </button> -->
      </div>
    </div>

    <div *ngIf="ShowResultScreen">
      <div class="suc_msg" *ngIf="otpverified">
        <img src="assets/img/success.png" width="52px" /><br /><br />
        <p style="color: var(--textcolor4)">Phone number verified</p>
        <h2>Successfully!</h2>
        <button
          mat-raised-button
          class="next-btn m-b-20"
          color="warn"
          (click)="funcShowDashboard()"
        >
          Done
        </button>
        <!-- <button mat-raised-button class="next-btn m-b-20" color="warn">
          Done
        </button> -->
      </div>
      <div class="suc_msg" *ngIf="!otpverified">
        <img src="assets/img/failed.png" width="52px" /><br /><br />
        <p style="font-size: 28px">{{ errorMsg }}</p>
        <p *ngIf="isBeforeOtp">Please Contact Admin</p>
        <button
          *ngIf="!isBeforeOtp"
          mat-raised-button
          class="next-btn m-b-20"
          color="warn"
          (click)="funcShowOtpScreen()"
        >
          Back
        </button>
        <!-- <button
          *ngIf="!isBeforeOtp"
          mat-raised-button
          class="next-btn m-b-20"
          color="warn"
        >
          Back
        </button> -->
        <button
          *ngIf="isBeforeOtp"
          mat-raised-button
          class="next-btn m-b-20"
          color="warn"
          (click)="funcShowMobileScreen()"
        >
          ok
        </button>
        <!-- <button
          *ngIf="isBeforeOtp"
          mat-raised-button
          class="next-btn m-b-20"
          color="warn"
        >
          ok
        </button> -->
      </div>
    </div>
  </div>
</div>
